import { CellValue } from '../types.js';
import { computeLeftmost } from './techniques.js';
import type { SolverLine } from './types.js';

/**
 * Check if a partially-filled line can still satisfy the given clues.
 * Returns false if no valid placement exists (contradiction detected).
 */
export function isLineValid(line: SolverLine, clues: number[]): boolean {
  if (clues.length === 1 && clues[0] === 0) {
    // No filled cells allowed
    return !line.some((c) => c === CellValue.Filled);
  }

  // If leftmost placement exists, the line is still potentially valid
  return computeLeftmost(line, clues) !== null;
}
